"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedRuntimeError = void 0;
class UnsupportedRuntimeError extends Error {
    name = 'UnsupportedRuntimeError';
    code = 500;
    constructor(...args) {
        super(...args);
        Error.captureStackTrace(this, UnsupportedRuntimeError);
    }
}
exports.UnsupportedRuntimeError = UnsupportedRuntimeError;
//# sourceMappingURL=unsupported-runtime-error.js.map